import PlayerData from './player-data'

const Dashboard = () => {
  return (
    <div className='flex flex-wrap gap-4'>
        <PlayerData />
    </div>
  )
}

export default Dashboard